var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structure-mobile"},[_c('video',{staticClass:"video",attrs:{"muted":"","autoplay":"","playsinline":"","x-webkit-playsinline":"","x5-playsinline":"","loop":"","src":_vm.videoUrl,"type":"video/mp4"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }